import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <div className="footer__container ">
      <a
        target="_blank"
        href="http://anastasia-chuvakova.com/#/"
        className="p-3"
      >
        Site by: Anastasia Chuvakova
      </a>
      <NavLink
        className=" text-mainFooterLink"
        activeStyle={{ color: "" }}
        to="/"
      >
        About
      </NavLink>
      <NavLink
        className="footer__link"
        activeStyle={{ color: "" }}
        to="/charts"
      >
        Charts
      </NavLink>

      <NavLink
        className="footer__link "
        activeStyle={{ color: "" }}
        to="/publications_and_presentations"
      >
        Publications and Presentations
      </NavLink>
      <NavLink
        className="footer__link "
        activeStyle={{ color: "" }}
        to="/photography"
      >
        Photography
      </NavLink>
     
    </div>
  );
}
export default Footer;
